<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 5 : 2}`"
      class="pointer border mx-1 my-1 text-center grey lighten-5"
      height="100%"
    >
      <v-card-title class="pa-0"> </v-card-title>
      <v-row>
        <v-col cols="4"></v-col>
        <v-col cols="4">
          <v-avatar size="90" class="profile-img">
            <v-img :src="crmUserData.picture" class="white-border"></v-img>
          </v-avatar>
        </v-col>
        <v-col cols="4"></v-col>
      </v-row>
      <v-col class="pa-0">
        <a
          class="body-2 font-weight-medium blue--text link"
          v-text="crmUserData.name"
        ></a>

        <div class="grey--text caption">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ get(crmUserData, "division.name", "N/A") }}
              </span>
            </template>
            <span>
              {{ get(crmUserData, "division.name", "N/A") }}
            </span>
          </v-tooltip>
        </div>
        <a
          class="font-1 grey--text"
          @click="
            (crmUpdateUserForm = true) && (selectedCrmUserData = crmUserData)
          "
        >
          Edit
        </a>
        <v-card class="px-3 mt-3" flat extended>
          <v-divider></v-divider>
          <v-row class="grey--text text--darken-3 pa-2 text-truncate text-left">
            <v-col
              v-for="(organization, index) in crmUserData.organizations"
              :key="index"
              cols="6"
            >
              <div
                class="font-1 grey--text mb-1 text-center"
                v-text="organization.organization.name"
              ></div>
              <div class="d-flex">
                <span class="font-0 text-right mx-1">
                  <v-tooltip v-if="organization.is_admin" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        size="15"
                        v-text="$getIcon('mdiAccountBox')"
                        v-on="on"
                      >
                      </v-icon>
                    </template>
                    <span>
                      Administrator
                    </span>
                  </v-tooltip>
                </span>
                <span class="font-0 text-left mx-1">
                  <v-tooltip v-if="organization.deal_verifier" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        size="15"
                        v-on="on"
                        v-text="$getIcon('mdiCheckAll')"
                      >
                      </v-icon>
                    </template>
                    <span>
                      Deal Verifier
                    </span>
                  </v-tooltip>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-divider></v-divider>
      <v-card-actions class="pa-0 text-truncate text-left">
        <v-col class="pt-3 pb-0 px-0 grey--text caption text-center">
          <v-divider></v-divider>
          <div
            class="caption pa-2 grey--text font-weight-bold grey lighten-3"
            v-text="crmUserData.user_type"
          ></div>
        </v-col>
      </v-card-actions>

      <!-- CRM Update User Form -->
      <v-dialog v-model="crmUpdateUserForm" fullscreen>
        <v-card tile>
          <vue-card-title
            :title="`Update CRM User`"
            :subtitle="'Fill up the following form to update crm user.'"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="crmUpdateUserForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <crm-update-user-form
              v-if="selectedCrmUserData || crmUpdateUserForm"
              :action-data="selectedCrmUserData"
              @crmUserUpdateFormResponse="formSuccess"
            >
            </crm-update-user-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / CRM Update User Form -->
    </v-card>
  </v-hover>
</template>

<script>
import CrmUpdateUserForm from "@/components/crm/crm_user/forms/CrmUpdateUserForm";

export default {
  components: { CrmUpdateUserForm },
  props: {
    crmUserData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // crm update user form
      crmUpdateUserForm: false,
      selectedCrmUserData: null
    };
  },
  methods: {
    formSuccess() {
      this.crmUpdateUserForm = false;
      this.$emit("crmUpdateFormSuccess");
    }
  }
};
</script>

<style scoped>
.profile-img {
  position: relative;
  top: -30px;
}

.white-border {
  border: #efefef 3px solid;
}
.fab-button {
  z-index: 0;
  height: 35px;
  width: 35px;
}
</style>
